var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right"},[_c('el-button',{attrs:{"type":"danger","size":"mini","icon":"el-icon-delete","loading":_vm.loading},on:{"click":_vm.confirm_truncate}},[_vm._v("\n    Truncate Xero IDs\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }